module.exports = __webpack_public_path__ + "img/chair.f45c70b6.png";